import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientQuery, clientMutation } from '../../../../../../../config/helpers/GraphQLApi';

import { endpoints } from '../../../../../../../config/constants';
import { ExceptionManager } from '../../../../../../../config/helpers/Logging'
import { resetALL } from '../../../../../../../config/redux/actions'

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    isOpen: false,
    data: null,
    result: null,
    error: null,
    companyAnnouncementId: null,
    typeAnnouncement: 'COMPANY', // USER, COMPANY, TEAM
};

const route = 'modules/client/dashboard/modals/editNote/slice'

//Extend async Action
export const dashboardEditNoteOpen = createAsyncThunk('dashboard/editNote/open', async (
    payload,
    { rejectWithValue, dispatch, getState }
) => {
    try {

        if (!payload?.id) {
            return { data: null, companyAnnouncementId: payload?.companyAnnouncementId }
        }
        const { typeAnnouncement } = getState().dashboardEditNoteRedux;

        let serviceName = ''
        let keys = ''
        switch (typeAnnouncement) {
            case 'COMPANY':
                serviceName = 'getCompanyAnnouncementNoteById'
                keys = 'companyId companyAnnouncementId campaignDetailId'
                break;
            case 'USER':
                serviceName = 'getUserAnnouncementNoteById'
                keys = 'userId userAnnouncementId campaignDetailId'
                break;
            case 'TEAM':
                serviceName = 'getTeamAnnouncementNoteById'
                keys = 'teamAnnouncementId'
                break;
        }

        let data = await clientQuery(
            `query ${serviceName}($id: Int) {
                note: ${serviceName}(id: $id) {
                    id
                    ${keys}
                    emailSchedule
                    sendStatus
                    error
                    note
                    createdOn
                }
             }`,
            {
                id: Number(payload?.id)
            },
            endpoints.GRAPHQL_GENERAL
        );
        //Se retorna la data del server
        return { data: data.note, companyAnnouncementId: payload.companyAnnouncementId }
    } catch (exc) {
        //Se guarda la excepcion
        ExceptionManager(exc, route, 'dashboardEditNoteOpen', dispatch);
        return rejectWithValue(exc)
    }
})

export const dashboardEditNoteSave = createAsyncThunk('dashboard/editNote/save', async (
    {
        id, companyAnnouncementId, note, emailSchedule,
    },
    { rejectWithValue, dispatch, getState }
) => {
    const { typeAnnouncement } = getState().dashboardEditNoteRedux;
    let serviceNameUpdate = ''
    let serviceNameCreate = '';
    let paramCreate = '';

    switch (typeAnnouncement) {
        case 'COMPANY':
            serviceNameUpdate = 'updateCompanyAnnouncementNote'
            serviceNameCreate = 'createCompanyAnnouncementNote'
            paramCreate = 'companyAnnouncementId'
            break;
        case 'USER':
            serviceNameUpdate = 'updateUserAnnouncementNote'
            serviceNameCreate = 'createUserAnnouncementNote'
            paramCreate = 'userAnnouncementId'
            break;
        case 'TEAM':
            serviceNameUpdate = 'updateTeamAnnouncementNote'
            serviceNameCreate = 'createTeamAnnouncementNote'
            paramCreate = 'teamAnnouncementId'
            break;
    }
    try {
        let data
        if (id) {
            data = await clientMutation(
                `mutation ${serviceNameUpdate} ($id: Int, $note: String, $emailSchedule: Datetime) {
                    ${serviceNameUpdate} (id: $id, note: $note, emailSchedule: $emailSchedule)
                    {
                        id
                    }
                }`,
                {
                    id,
                    note,
                    emailSchedule: emailSchedule ? emailSchedule.format() : null,
                },
                endpoints.GRAPHQL_GENERAL
            );
        }
        else {
            //create
            data = await clientMutation(
                `mutation ${serviceNameCreate} ($companyAnnouncementId: Int, $note: String, $emailSchedule: Datetime) {
                    ${serviceNameCreate} (${paramCreate}: $companyAnnouncementId, note: $note, emailSchedule: $emailSchedule) 
                    {
                        id
                    }
                }`,
                {
                    companyAnnouncementId,
                    note,
                    emailSchedule: emailSchedule ? emailSchedule.format() : null,
                },
                endpoints.GRAPHQL_GENERAL
            );
        }
        return data
    } catch (exc) {
        ExceptionManager(exc, route, 'dashboardEditNoteSave', dispatch);
        return rejectWithValue(exc)
    }
})

//Slice
const dashboardEditNoteRedux = createSlice({
    name: 'dashboard/editNote',
    initialState: INIT_STATE,
    reducers: {
        dashboardEditNoteClose(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        //thunk dashboardEditNoteOpen
        builder.addCase(dashboardEditNoteOpen.pending, (state, action) => {
            state.typeAnnouncement = action.meta.arg?.typeAnnouncement
            state.loading = true
            state.isOpen = true
        })
        builder.addCase(dashboardEditNoteOpen.fulfilled, (state, { payload }) => {
            state.loading = false
            state.data = payload.data
            state.companyAnnouncementId = payload.companyAnnouncementId
        })
        builder.addCase(dashboardEditNoteOpen.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })

        //thunk dashboardEditNoteSave
        builder.addCase(dashboardEditNoteSave.pending, (state) => {
            state.loading = true
            state.result = null
            state.error = null
        })
        builder.addCase(dashboardEditNoteSave.fulfilled, (state, { payload }) => {
            state.loading = false
            state.result = payload
        })
        builder.addCase(dashboardEditNoteSave.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = dashboardEditNoteRedux;

// Extract and export each action creator by name
export const { dashboardEditNoteClose, reset } = actions;

//Simple async action

// Export the reducer, either as a default or named export
export default reducer;